import {
    REGISTRATION,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    EDIT_REGISTRATION,
    EDIT_REGISTRATION_FAILURE,
    EDIT_REGISTRATION_SUCCESS
} from "../Constants";

export const Registration = (payload) => ({
    type: REGISTRATION,
    payload
});

export const RegistrationSuccess = (payload) => ({
    type: REGISTRATION_SUCCESS,
    payload
});

export const RegistrationFailure = (payload) => ({
    type: REGISTRATION_FAILURE,
    payload
});

export const EditRegistration = (payload) => ({
    type: EDIT_REGISTRATION,
    payload
});

export const EditRegistrationSuccess = (payload) => ({
    type: EDIT_REGISTRATION_SUCCESS,
    payload
});

export const EditRegistrationFailure = (payload) => ({
    type: EDIT_REGISTRATION_FAILURE,
    payload
});